import React, { useMemo } from 'react';
import { AppView, Spacer, StatusBar, withAnimatedNavigationHeader, } from 'design-system';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import InfoCard from 'design-system/InfoCard';
import Text from 'design-system/Text';
import { getFilterPreview } from 'actions';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import TransactionsPreview from '../../transactions/components/TransactionsPreview';
import { isWeb } from '../../../constants';
const strings = {
    title: 'Detected transactions',
};
const SmartRuleDetectedTransactionsScreen = withAnimatedNavigationHeader(({ route, scrollHandler }) => {
    const query = useMemo(() => ({
        ...route.params,
        accountIds: `[${route.params.accountIds.join(',')}]`,
    }), [route.params]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    const ListHeaderComponent = useMemo(() => (<>
            <Spacer.H8 />
            <InfoCard>
              <Text TextThin-14 Secondary>
                These are the transactions matched based on your filters; the
                rule will only trigger on future transactions that follow your
                filters.
              </Text>
            </InfoCard>
            <Spacer.H8 />
          </>), []);
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <TransactionsPreview onScroll={scrollHandler} contentContainerStyle={paddingBottom} ListHeaderComponent={ListHeaderComponent} query={query} endpoint={getFilterPreview}/>
        </AppView>);
}, ({ colors }) => ({
    title: strings.title,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default SmartRuleDetectedTransactionsScreen;
